/* eslint-disable */
<template>
    <div class="page-container">
        <div class="page-header">
            <div class="title">声纹管理</div>
            <div class="subtitle">管理和维护系统中的用户声纹信息</div>
        </div>
        
        <div class="content-container">
            <div ref="searchRef" class="top-box">
                <a-space style="display: flex; justify-content: space-between; width: 100%;">
                    <a-button type="primary" @click="addUser">新建</a-button>
                    <a-space class="search-box">
                        <a-input class="search-input" v-model:value="searchState.name" placeholder="请输入姓名" allowClear @pressEnter="refreshTable" />
                        <a-button class="search-btn" type="primary" @click="refreshTable">搜索</a-button>
                        <a-button type="primary" ghost @click="batchDelete">批量删除</a-button>
                    </a-space>
                </a-space>
            </div>
            <a-table ref="tableRef" :columns="columns" :row-key="record => record.key" :data-source="dataSource"
                :pagination="pagination" :loading="loading" @change="handleTableChange"
                :rowSelection="{ 
                    columnWidth: 100, 
                    onChange: rowSelectionChange,
                    selectedRowKeys: selectedKeys.value
                }" class="flex-grow-table">
                <template #bodyCell="{ column, text, record }">
                    <template v-if="column.dataIndex === 'name'">{{ text }}</template>
                    <template v-else-if="column.dataIndex === 'audio_path'">
                        <span :style="{ color: text ? '#52c41a' : '#bfbfbf' }">{{ text ? '已录入' : '—' }}</span>
                    </template>
                    <template v-else-if="column.key === 'action'">
                        <a-space>
                            <a-button type="link" :icon="h(EditOutlined)" @click="edit(record.key)">编辑</a-button>
                            <a-button type="link" :icon="h(DeleteOutlined)" @click="del(record.key)">删除</a-button>
                        </a-space>
                    </template>
                </template>
            </a-table>
        </div>
        <!-- 新增、编辑 -->
        <UserAddModal v-model:open="modalVisible" :form-id="currentId" @save-success="refreshTable" />
    </div>
</template>

<script setup>
import { ref, createVNode, onActivated, h, reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import axios from 'axios';
import { Modal, message } from 'ant-design-vue';
import { ExclamationCircleOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons-vue';
import UserAddModal from '@/views/UserAdd.vue';
import { BASE_URL } from '@/config/api';
const columns = [
    {
        title: '组织',
        dataIndex: 'role',
        sorter: false,
    },
    {
        title: '姓名',
        dataIndex: 'name',
        sorter: false,
    },
    {
        title: '声纹',
        dataIndex: 'audio_path',
        sorter: false,
    },
    {
        title: '创建时间',
        dataIndex: 'create_time',
        sorter: true,
    },
    {
        title: '操作',
        key: 'action',
        width: '300px',
        align: 'center'
    }
];

const dataSource = ref([]);
const loading = ref(false);
const pagination = ref({ current: 1, pageSize: 10, total: 0 });

const myPermission = computed(() => {
    const permission = localStorage.getItem('myPermission') || '{}'
    return JSON.parse(permission)
})

const fetchData = async (page, pageSize, sortField, sortOrder, filters, searchKeyword) => {
    loading.value = true;
    try {
        const response = await axios.get(`${BASE_URL}/user`, {
            params: {
                page,
                size: pageSize,
                sortField,
                sortOrder,
                ...filters,
                name: searchKeyword,
                active_id: myPermission.value.id
            },
        });
        const data = response.data;
        if (Array.isArray(data.items)) {
            console.log('data.items', data.items)
            dataSource.value = data.items.map(item => ({
                key: item.id,
                name: item.name,
                audio_path: item.audio_path,
                phone: item.phone,
                role: item.role,
                create_time: item.create_time
            }));
            pagination.value.total = data.total;
            pagination.value.current = data.page;
            pagination.value.pageSize = data.size;
        } else {
            console.error('API response is not an array:', data);
        }
    } catch (error) {
        console.error('Failed to fetch data:', error);
    } finally {
        loading.value = false;
    }
};



const handleTableChange = (pag, filters, sorter) => {
    fetchData(pag.current, pag.pageSize, sorter.field, sorter.order, filters, searchState.name);
};

const refreshTable = () => {
    pagination.value.current = 1
    fetchData(pagination.value.current, pagination.value.pageSize, null, null, {}, searchState.name);
}


onActivated(() => {
    // 初始数据加载
    fetchData(pagination.value.current, pagination.value.pageSize, null, null, {}, searchState.name);
})

const modalVisible = ref(false)
const currentId = ref()
const addUser = () => {
    modalVisible.value = true
}
const edit = (id) => {
    currentId.value = id;
    modalVisible.value = true
}

const del = (id) => {
    // 确认框提示
    Modal.confirm({
        title: '提示',
        content: '确认删除该用户声纹吗？',
        icon: createVNode(ExclamationCircleOutlined),
        okText: '确认',
        cancelText: '取消',
        async onOk() {
            try {
                loading.value = true;
                const response = await axios.delete(`${BASE_URL}/user/${id}`);
                console.log('Deleted successfully', response);
                message.success('删除成功');
                await fetchData(pagination.value.current, pagination.value.pageSize, null, null, {}, searchState.name);
            } catch (error) {
                console.error('Failed to delete:', error);
                message.error(error.response?.data?.message || '删除失败，请稍后重试');
            } finally {
                loading.value = false;
            }
        },
    });

}

const selectedKeys = ref([])
const rowSelectionChange = (selectedRowKeys) => {
    selectedKeys.value = selectedRowKeys;
}
const batchDelete = () => {
    if (selectedKeys.value.length === 0) {
        message.warning('请至少选择一条数据进行删除');
        return;
    }
    Modal.confirm({
        title: '提示',
        content: `确认删除选中的 ${selectedKeys.value.length} 条声纹记录吗？`,
        icon: createVNode(ExclamationCircleOutlined),
        okText: '确认',
        cancelText: '取消',
        async onOk() {
            try {
                loading.value = true;
                const response = await axios.delete(`${BASE_URL}/user/batch`, {
                    data: { ids: selectedKeys.value }
                });
                console.log('Batch deleted successfully', response);
                message.success(`成功删除 ${selectedKeys.value.length} 条记录`);
                selectedKeys.value = [];
                pagination.value.current = 1;
                await fetchData(pagination.value.current, pagination.value.pageSize, null, null, {}, searchState.name);
            } catch (error) {
                console.error('Failed to batch delete:', error);
                message.error(error.response?.data?.message || '批量删除失败，请稍后重试');
            } finally {
                loading.value = false;
            }
        },
    });
}

const searchRef = ref()
const tableRef = ref()

onMounted(() => {
    // fetchData call removed, handled by onActivated
});

onBeforeUnmount(() => {
    // ResizeObserver logic removed
});

const searchState = reactive({
    name: ''
});

</script>
<style scoped>
.page-container {
    min-height: 100%;
    height: 100%;
    padding: 24px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.content-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 24px;
}

.top-box {
    margin-bottom: 22px;
}

.top-box .ant-btn {
    min-width: 80px;
}

.search-input {
    /* width: 310px; */ /* Removed fixed width */
}

/* Add style for table to grow */
.flex-grow-table {
    flex-grow: 1;
    overflow: auto; /* Allow table itself to scroll if content overflows */
}
</style>